// export const BASE_URL = "https://api.zarpsoftware.in/api";
// export const AuthURL = "https://api.zarpsoftware.in/auth";
// export const BASE_URL = "https://qaapi.zarpsoftware.in/api";
// export const AuthURL = "https://qaapi.zarpsoftware.in/auth";
// export const BASE_URL = "http://192.168.31.95:8099/api";
// export const AuthURL = "http://192.168.31.95:8099/auth";


export const BASE_URL = "https://tradingapi.zarpsoftware.in/api";
export const AuthURL = "https://tradingapi.zarpsoftware.in/auth";

// export const BASE_URL = "https://manufacturing.zarpsoftware.in/api";
// export const AuthURL = "https://manufacturing.zarpsoftware.in/auth";
//export NODE_OPTIONS="--openssl-legacy-provider --max-old-space-size=12288";
